<template>
  <v-container fluid grid-list-xs>
    <v-dialog v-model="visible" :max-width="width" persistent>
      <v-card class="dialog-card">
        <v-card-title class="grey lighten-2">
          <v-icon>mdi-format-list-checks</v-icon>
          <span>{{ getTitle() }}</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="card-body">
          <v-container>
            <v-row>
              <v-col col="3">
                <v-btn block class="ma-2" @click="doAddAll">{{ addAllLabel }}</v-btn>
              </v-col>
              <v-col col="3">
                <v-btn block class="ma-2" @click="doRemoveAll">{{ removeAllLabel }}</v-btn>
              </v-col>
              <v-col col="3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn block class="ma-2" color="primary" v-on="on" @click="doSortAsc">
                      {{ sortLabel }}
                      <v-icon right>mdi-sort-ascending</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ sortAscLabel }}</span>
                </v-tooltip>
              </v-col>
              <v-col col="3">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn block class="ma-2" color="primary" v-on="on" @click="doSortDsc">
                      {{ sortLabel }}
                      <v-icon right>mdi-sort-descending</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ sortDscLabel }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card outlined class="list-card">
                  <v-list lines="one" dense class="scroll-list">
                    <v-list-item v-for="item in columnsListA" :key="item.value">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn small color="primary" icon @click="doAdd(item)">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col>
                <v-card outlined class="list-card">
                  <v-list lines="one" dense class="scroll-list">
                    <draggable v-model="columnsListB" v-bind="{ animation: 200, handle: '.drag-handle' }" item-key="value">
                      <v-list-item v-for="item in columnsListB" :key="item.value" :value="item.value">
                        <v-list-item-icon class="drag-handle">
                          <v-icon small>mdi-drag</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn small color="red" icon @click.stop="doRemove(item)">
                            <v-icon small>mdi-minus</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </draggable>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer />
              <v-btn color="error" class="ma-2" @click="visible = false"
                ><span>{{ cancelLabel }}</span
                ><v-icon right small>mdi-close</v-icon></v-btn
              >
              <v-btn color="primary" class="ma-2" @click="doExport"
                ><span>{{ exportLabel }}</span
                ><v-icon right small>mdi-file-excel</v-icon></v-btn
              >
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import clone from 'clone'
import draggable from 'vuedraggable'

export default {
  data() {
    return {
      title: 'Select the column(s)',
      visible: false,
      resolve: null,
      exportLabel: 'Export',
      cancelLabel: 'Cancel',
      sortLabel: 'Sort',
      sortAscLabel: 'Ascending',
      sortDscLabel: 'Descending',
      addAllLabel: 'Add all',
      removeAllLabel: 'Remove all',
      columnsListA: [],
      columnsListB: []
    }
  },
  watch: {
    value: function(value) {
      this.visible = value
    },
    visible: function(value) {
      if (!value) {
        this.$emit('input', false)
      }
    }
  },
  methods: {
    getTitle() {
      if (this.titleTabDet !== '') {
        return this.title + ' for ' + this.titleTabDet
      } else {
        return this.title
      }
    },
    doOk() {
      this.$emit('ok', this.selectedColumnsA)
      if (this.resolve) {
        this.resolve(true)
      }
      this.visible = false
    },
    doCancel() {
      this.$emit('cancel')
      if (this.resolve) {
        this.resolve(false)
      }
      this.visible = false
    },
    doSortAsc() {
      this.columnsListB.sort((a, b) => a.text.localeCompare(b.text))
    },
    doSortDsc() {
      this.columnsListB.sort((a, b) => b.text.localeCompare(a.text))
    },
    doAdd(item) {
      this.columnsListB.push(item)
      const indexA = this.columnsListA.findIndex(i => i.value === item.value)
      if (indexA !== -1) {
        this.columnsListA.splice(indexA, 1)
      }
    },
    doAddAll() {
      this.columnsListA.forEach(i => {
        this.columnsListB.push(i)
      })
      this.columnsListA = []
    },
    doRemove(item) {
      this.columnsListA.push(item)
      const indexB = this.columnsListB.findIndex(i => i.value === item.value)
      if (indexB !== -1) {
        this.columnsListB.splice(indexB, 1)
      }
      this.columnsListA.sort((a, b) => a.text.localeCompare(b.text))
    },
    doRemoveAll() {
      this.columnsListB.forEach(i => {
        this.columnsListA.push(i)
      })
      this.columnsListB = []
      this.columnsListA.sort((a, b) => a.text.localeCompare(b.text))
    },
    doExport() {
      if (this.columnsListB.length === 0) {
        this.$toast.error('Please select at least one column to export.')
      } else {
        let result = []
        let resultTitle = []
        this.columnsListB.forEach(i => {
          result.push(i.value)
          resultTitle.push(i.text)
        })
        this.$emit('export', result.join(','), resultTitle.join(','))
        if (this.resolve) {
          this.resolve(true)
        }
        this.visible = false
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '760px'
    },
    columns: {
      type: Array,
      default: null
    },
    titleTabDet: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.visible = this.value
    this.columnsListA = clone(this.columns.sort((a, b) => a.text.localeCompare(b.text)))
  },
  components: { draggable }
}
</script>

<style lang="scss">
.drag-handle {
  cursor: move;
}
.dialog-card {
  height: 620px;
  display: flex;
  flex-direction: column;
}
.card-body {
  flex: 1;
  overflow: hidden;
}
.list-card {
  height: 390px;
  display: flex;
  flex-direction: column;
}
.scroll-list {
  overflow-y: auto;
  flex: 1;
}
</style>
